export enum WidgetListItems {
    WATCHLIST = "WLT",
    OVERVIEW = "OVW",
    MARKET_NEWS = "NWS",
    ALERT = "ALR",
    TRADE = "TRD",
    POSITIONS = "POS",
    ORDERS = "ORD",
    NOTIFICATION='NTF',
    HOLDINGS = "HLD"
}